/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Delete_Success_DescInputs */

const es_feedback_delete_success_desc = /** @type {(inputs: Feedback_Delete_Success_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El feedback fue eliminado correctamente y ya no estará disponible.`)
};

const en_feedback_delete_success_desc = /** @type {(inputs: Feedback_Delete_Success_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The feedback was successfully deleted and is no longer available.`)
};

/**
* | output |
* | --- |
* | "The feedback was successfully deleted and is no longer available." |
*
* @param {Feedback_Delete_Success_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_delete_success_desc = /** @type {((inputs?: Feedback_Delete_Success_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Delete_Success_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_delete_success_desc(inputs)
	return en_feedback_delete_success_desc(inputs)
});
export { feedback_delete_success_desc as "feedback.delete.success_desc" }